import { ApiError, MediumScreenModel } from "components";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import {
  FeaturedAdsInput,
  FeaturedAdsInputError,
  stateStatusType,
} from "../state/actionType";
import FeaturedAdsForm from "./form/FeaturedAdsApp";
import { connect, useSelector } from "react-redux";
import { createFeaturedAds, ResetFeaturedAds } from "../state/action";
import { FormDataValidation } from "./components/FormDataValidation";
import { FeaturedAdsEnum, FeaturedAdsStatusEnum } from "props/enum";
import HandleUploadFeaturedAdsVideo from "./HandleUploadFeaturedAdsVideo";

interface OwnProps {
  onClose: () => void;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleCreateFeaturedAds: React.FC<Props> = ({
  onClose,
  onResetFeaturedAds,
  onCreateFeaturedAds,
}) => {
  const featuredAdsState = useSelector(
    (state: any) => state.featuredAds.genericFeaturedAdsState
  );
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [openUploadVideo, setUploadVideo] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [videoFile, setVideoFile] = useState<File | null>(null);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [formData, setFormData] = useState<FeaturedAdsInput>({
    featured_type: "",
    status: "Draft",
    image: "",
    video: "",
    featured_order: 0,
    name: "",
  });
  const [formError, setFormError] = useState<FeaturedAdsInputError>({});
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "featured_order" ? Number(value) : value,
    }));
    setFormError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    const validationErrors = FormDataValidation(formData);
    if (Object.keys(validationErrors).length > 0) {
      setFormError(validationErrors);
      return;
    }
     setLoading(true);
    const input: FeaturedAdsInput = {
      name: formData.name,
      featured_type: formData.featured_type,
      status: FeaturedAdsStatusEnum.Draft,
      featured_order: formData.featured_order,
    };
    let uploadedFilename: string | undefined = undefined;
    if (imageFile) {
      const uploadUrl = `${process.env.REACT_APP_FEATURED_ADS_UPLOAD_IMAGE_BASE_URL}`;
      const form = new FormData();
      form.append("file", imageFile);
      const response = await fetch(uploadUrl ?? "", {
        method: "POST",
        body: form,
      });
      if (!response.ok) {
        const errorText = await response.text();
        console.error("Upload failed:", errorText);
        throw new Error("Failed to upload image");
      }
      const result = await response.json();
      uploadedFilename = result?.featuredImageUrl;

      if (!uploadedFilename) {
        console.error("Image upload response invalid", result);
        throw new Error("Image upload response invalid");
      }
    } else if(videoFile) {
      const uploadUrl = `${process.env.REACT_APP_FEATURED_ADS_UPLOAD_VIDEO_BASE_URL}`;
      const form = new FormData();
      form.append("file", videoFile);
      const response = await fetch(uploadUrl ?? "", {
        method: "POST",
        body: form,
      });
      if (!response.ok) {
        const errorText = await response.text();
        console.error("Upload failed:", errorText);
        throw new Error("Failed to upload video");
      }
      const result = await response.json();
      uploadedFilename = result?.featuredVideoUrl;

      if (!uploadedFilename) {
        throw new Error("Video upload response invalid");
      }
    }
    if (
      formData.featured_type.trim() !== "" &&
      formData.name.trim() !== "" &&
      formData.featured_order !== 0
    ) {
      if(uploadedFilename){
        if(formData.featured_type === FeaturedAdsEnum.image){
          input.image = uploadedFilename;
        } else if(formData.featured_type === FeaturedAdsEnum.video){
          input.video = uploadedFilename;
        }
      }
      onCreateFeaturedAds(input);
      setSubmitted(true);
    }
     setLoading(false);
  };
 useEffect(() => {
  if (!featuredAdsState.isLoading && submitted) {
    if (featuredAdsState.error) {
      setApiError(featuredAdsState.error);
    } else if (featuredAdsState.status === stateStatusType.SUCCESS && (formData.featured_type === FeaturedAdsEnum.image || formData.featured_type === FeaturedAdsEnum.video)) {
      onClose();
      onResetFeaturedAds(); 
    } else {
      setApiError(null);
    }
  }
}, [featuredAdsState.isLoading, featuredAdsState.error, featuredAdsState.status, submitted]);

  // useEffect(() => {
  //   if (featuredAdsState.status === stateStatusType.SUCCESS) {
  //     if (formData.featured_type === FeaturedAdsEnum.video) {
  //       setUploadVideo(true);
  //     }
  //   }
  // }, [featuredAdsState.status]);
  useEffect(() => {
    onResetFeaturedAds();
  }, []);
  return (
    <>
      {openUploadVideo ? (
        <>
          <HandleUploadFeaturedAdsVideo
            videoFile={videoFile}
            onClose={onClose}
          />
        </>
      ) : (
        <>
          <FeaturedAdsForm
            header={"Create Featured Ads"}
            formData={formData}
            formError={formError}
            handleChange={handleChange}
            handleSubmit={handleSave}
            loading={loading}
            onClose={onClose}
            handleVideoFileChange={setVideoFile}
            handleImageFileChange={setImageFile}
            isNewVideo={true}
            posterUrl={null}
          />
          {apiError && <ApiError>{apiError}</ApiError>}
        </>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onCreateFeaturedAds: (input: FeaturedAdsInput) =>
    dispatch(createFeaturedAds(input)),
  onResetFeaturedAds: () => dispatch(ResetFeaturedAds()),
});
export default connect(null, mapDispatchToProps)(HandleCreateFeaturedAds);
